import Home from './home'
import RebateList from "./rebateList";
export default {
    Home,
    RebateList,
}